// Shared between the light mount point (DemoVideoModalRoot.jsx, in every
// page's bundle) and the lazy-loaded modal (DemoVideoModal.jsx, fetched on the
// first open together with video.js). Kept dependency-free on purpose.

// Every video the modal can play. Each is committed HLS under public/marketing/
// (masters stay out of git); the key is what `window.openDemoTour(source, key)`
// takes, defaulting to the demo walkthrough so existing call sites are untouched.
export const VIDEOS = {
  demo: {
    source: '/marketing/videos/demo-walkthrough/demo-1080p.m3u8',
    poster: '/marketing/videos/demo-walkthrough/demo-poster.jpg',
    subtitles: '/marketing/videos/demo-walkthrough/demo-en.vtt',
    titleKey: 'demoModal.title',
    metaKey: 'demoModal.meta',
  },
  forensics: {
    source: '/marketing/videos/investigation-canvas/forensics-1080p.m3u8',
    poster: '/marketing/videos/investigation-canvas/forensics-preview-poster.jpg',
    subtitles: '/marketing/videos/investigation-canvas/forensics-en.vtt',
    titleKey: 'widgets.forensics.deepDive.modalTitle',
    metaKey: 'widgets.forensics.deepDive.modalMeta',
  },
};

export function emitDemoEvent(event, source, video = 'demo') {
  const detail = {
    event,
    source: source || 'unknown',
    video,
    page_path: window.location.pathname,
  };
  window.dataLayer?.push(detail);
  window.gtag?.('event', event, detail);
  window.dispatchEvent(new CustomEvent('scopeworth:analytics', { detail }));
}
